import React, { Component } from 'react';
import Graphs from '../../_components_main/Graphs';
import states from '../../_components/options/states';
import { connect } from 'react-redux'
import { setAnalyticsDataTypes } from 'store/functions/analytics_data_types/analytics_data_types'
import Circle from 'components/markup/loading/Circle';
import getDataFieldInputs from 'views/admin/pages/_functions/getDataFieldInputs'
import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import { Container } from 'reactstrap';
class ContactsGraphs extends Component {

    state = {
        loaded: false,
        collection: 'contacts'
    };

    componentDidMount = async () => {

        // if we dont have data types and data_types length, run redux action to accomplish this
        if(!this.props.analytics_data_types.length) await setAnalyticsDataTypes()

        this.setState({loaded: true})

    }

    render() {

        if(!this.state.loaded) return <div className="py-6"><Circle /></div>
        const customInputs = getDataFieldInputs(this.props.analytics_data_types, this.state.collection, true)

        return (

            <>

            <Container fluid>
                <DashHeaderOpen
                    title={<span><i className="fas fa-headset mr-2 text-success " />Analytics</span>}
                    breadcrumb_1="Contacts"
                    breadcrumb_2="Graphs"
                />
            </Container>

            <Graphs

                titleMain="Contact Graphs"
                titleFilter="Contact Graph Filters"

                collection={this.state.collection}

                setup={[
                    { name: 'Time Series',                            type: 'line',   size: 12,   },
                    { name: 'Raw Data',                               type: 'bar',    size: 8,    },
                    { name: 'Filter Breakdown',                       type: 'pie',    size: 4,    },
                    { name: 'Average Contact Attempts By Time Frame', type: 'average',    size: 4,   groups: ['$times_contacted'],   label: 'Contacted ${} Times' },
                    { name: 'Total Times Contacted',                  type: 'group',      size: 8,   groups: ['$times_contacted'],   label: 'Contacted ${} Times' },
                    { name: 'Average Days To Convert',                type: 'group',      size: 8,   groups: ['$time_to_convert'],   label: 'Converted In ${} Days', format: 'days' },
                    { name: 'Average Days To Convert By Time Frame',  type: 'average',    size: 4,   groups: ['$time_to_convert'],   label: 'Contacted ${} Times', format: 'days' },
                ]}

                inputs={[

                    [ // column 1
                        {
                            type: 'ArchkSelect', field: 'gender', label: 'Gender',
                            data: [
                                {value: 'male', text: 'Male'},
                                {value: 'female', text: 'Female'},
                                {value: 'unknown', text: 'Unknown'},
                            ]
                        },
                        {
                            type: 'ArchkSelect', field: 'state', label: 'State',
                            data: states
                        },
                        {
                            type: 'ArchkString', field: 'postal_code', label: 'Postal Code',
                        }
                    ],

                    [ // column 2
                        {
                            type: 'ArchkInArray', field: 'type', label: 'Contact Type', query: 'in',
                            data: [
                                {value: 'Client', text: 'Client'},
                                {value: 'Potential Client', text: 'Potential Client'}, 
                                {value: 'Unwanted Client', text: 'Unwanted Client'},
                                {value: 'No Show', text: 'No Show'},
                                {value: 'Hard Of Hearing', text: 'Hard Of Hearing'},
                                {value: 'Only Speaks Spanish', text: 'Only Speaks Spanish'},
                                {value: 'Only Speaks Arabic', text: 'Only Speaks Arabic'},
                            ]
                        },
                        {
                            type: 'ArchkNull', field: 'password', label: 'Has Logged In',
                        },
                    ],

                    customInputs[0],
                    customInputs[1],

                ]}
            />

            </>

        )

    }

}



const mapStateToProps = state => {

    return {
        analytics_data_types: state.analytics_data_types.analytics_data_types
    };
};

export default connect(mapStateToProps, '')(ContactsGraphs);
